//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 21/02/2025
// Version : 1
// Description : pantalla de modelo para reguladores
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Typography,
  Tooltip,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  DialogTitle,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Navbar from "../../Navbar";
import Notify from "../../Notify";
import { logEventos } from "../../../services/services";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BlockIcon from "@mui/icons-material/Block";
import AddModelosReg from "./AddModelosReg";
import EditarModelosReg from "./EditarModelosReg";

function Reguladores_modelos(props) {
  const [modelo, setModelo] = useState(); //p/tabla
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true);
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de choferes
  const [row, setRow] = useState(props.row);
  const [confirmar, setConfirmar] = useState(false);
  const [datosModelo, setDatosModelo] = useState({});
  const globalTheme = useTheme();
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [obt, setObt] = useState(0);
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  const [update, setUpdate] = useState(false);
  const [dialogAdd, setDialogAdd] = useState(false);
  const [dialogEditar, setDialogEditar] = useState(false);
  //    //acceso al menu
  useEffect(() => {
    logEventos(
      "Acceso al menú Modelos Reguladores",
      "Marcas y Modelos Reguladores",
      "Agregar,editar,activar o desactivar un Modelo ",
      localStorage.getItem("user")
    );
  }, []);
  //*************************************************************************************************************************************/

  // console.log("row Viene", row.original);
  const obtenerModelo = () => {
    fetch(
      UrlApi + "/reguladores_marcas/modelosXmarcas/" + row.original.id_marca
    )
      .then((data) => data.json())
      .then((data) => setModelo(data));
  };

  useEffect(() => {
    obtenerModelo();
  }, []);

  const handleClickNuevo = () => {
    setAlta(true);
    setDialogAdd(true);
  };

  const handleCloseAdd = () => {
    setDialogAdd(false);
    setUpdate(true);
  };

  const mostrareditar = (datosDeLaLinea) => {
    setDialogEditar(true);
    setDatosModelo(datosDeLaLinea);
    //console.log("datos linea",datosDeLaLinea ? datosDeLaLinea : "NO");
  };

  const handleCloseEditar = () => {
    setDialogEditar(false);
    setUpdate(true);
  };

  const handleVolver = () => {
    setConfirmar(false);

    setTabla(true);
  };

  useEffect(() => {
    if (update) {
      obtenerModelo();
      setUpdate(false);
    }
  }, [update]);

  const abrirModalConfirmar = (datosDeLaLinea) => {
    setConfirmar(true);
    setDatosModelo(datosDeLaLinea);
  };

  // columnas tabla
  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "id_modelo",
        size: 40,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Descripción",
        accessorKey: "descripcion_modelos",
        size: 200,
        muiTableBodyCellProps: { align: "left" },
      },
    ],
    []
  );
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };
  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const marcarInactivo = async (e) => {
    logEventos(
      "Marca inactivo un Modelo ",
      "Marcas y Modelos Reguladores",
      "Se inactivo el modelo",
      localStorage.getItem("user")
    );
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/reguladores_modelos/" + datosModelo.id_modelo,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          datosModelo.estado_modelo === 0
            ? { estado_modelo: 1 }
            : { estado_modelo: 0 }
        ),
      }
    );
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      alert("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar RTA Api."
          );
          obtenerModelo();
        } else if (json.sqlMessage) {
          json && setError(json);
          alert("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
        } else {
          alert("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado");
          obtenerModelo();
        } else {
          alert("Error: " + error);
        }
      }
    }
    handleVolver();
    obtenerModelo();
  };

  return (
    <div>
      <Navbar />
      <Container maxWidth="xl" mt={1} mb={2}>
        {modelo && tabla ? (
          <Box mt={2} boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                columns={columns}
                data={modelo}
                initialState={initialState}
                positionActionsColumn="last"
                enableExpandAll={false}
                enableToolbarInternalActions={true}
                muiTableHeadCellProps={tableHeadCellProps}
                autoResetPageIndex={false}
                muiTableBodyCellProps={({ row }) => ({
                  // align: "left",
                  sx: {
                    backgroundColor:
                      row.original.estado_modelo === 0 ? "#efc3c3" : "#b3e6b3",
                    color: "black",
                    borderColor: "black",
                  },
                })}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                renderTopToolbarCustomActions={() => (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={handleClickNuevo}
                    >
                      Nuevo Modelo
                    </Button>
                    <Typography variant="poster" fontSize={26}>
                      Modelo
                    </Typography>
                  </>
                )}
                layoutMode="grid"
                localization={MRT_Localization_ES}
                enableColumnDragging={false} //No permite que se arrastren las columnas.
                enableEditing
                renderRowActions={(
                  { row } //las acciones del costado editar y ver
                ) => (
                  <div>
                    <Tooltip arrow placement="left" title="Editar Modelo">
                      <IconButton
                        onClick={() => mostrareditar(row.original)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    {row.original.estado_modelo === 0 ? (
                      <Tooltip title="Marcar como activo">
                        <IconButton
                          color="success"
                          onClick={() => abrirModalConfirmar(row.original)}
                        >
                          <CheckCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Marcar como inactivo">
                        <IconButton
                          onClick={() => abrirModalConfirmar(row.original)}
                          color="error"
                        >
                          <BlockIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
              />
            </ThemeProvider>
            <br />
            <br />
          </Box>
        ) : null}

        {confirmar ? (
          <div>
            <Dialog open={confirmar} onClose={handleVolver}>
              <form onSubmit={marcarInactivo}>
                <Box backgroundColor={"#1F618D"}>
                  <DialogTitle>
                    <Typography
                      component="div"
                      align="center"
                      color="#ffffff"
                      sx={{ fontSize: "1.25rem", fontWeight: 500 }}
                    >
                      {datosModelo.estado_modelo === 0
                        ? `Activar ${datosModelo.descripcion_modelos}`
                        : ` Desactivar ${datosModelo.descripcion_modelos}`}
                    </Typography>
                  </DialogTitle>
                </Box>
                <DialogContent>
                  <DialogContentText textAlign={"center"}>
                    {datosModelo.estado_modelo === 0 ? (
                      <> ¿Desea activar el modelo ? </>
                    ) : (
                      <> ¿Desea desactivar el modelo? </>
                    )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Button
                      variant="contained"
                      onClick={handleVolver}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </DialogActions>
              </form>
            </Dialog>
          </div>
        ) : null}

        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleVolver}
          />
        ) : null}

        {dialogAdd ? (
          <AddModelosReg
            dialogAdd={dialogAdd}
            datos={datosModelo}
            actualizar={setObt}
            onClose={() => handleCloseAdd(false)}
            alta={setAlta}
            tabla={setTabla}
            row={row.original}
          ></AddModelosReg>
        ) : null}
        {dialogEditar ? (
          <EditarModelosReg
            dialogEditar={dialogEditar}
            datos={datosModelo}
            actualizar={setObt}
            onClose={() => handleCloseEditar(false)}
            editar={setEditar}
            tabla={setTabla}
          ></EditarModelosReg>
        ) : null}
      </Container>
    </div>
  );
}

export default Reguladores_modelos;
